import { detectArtworkContent } from "./artworkContentBounds";

export const analyzePlaqueArtwork = detectArtworkContent;
export function plaqueArtworkBounds(image) {
  return detectArtworkContent(image).bounds;
}

// Normalization bounds are in the ORIGINAL canvas. Approved masters start at
// paddingX/Y, so do not reuse the original left/top against the master image.
export function normalizedPlaqueBounds(metadata, width, height) {
  const info = metadata?.normalization;
  if (!info?.bounds) return null;
  const bounds = { left: info.paddingX, top: info.paddingY,
    width: info.bounds.right - info.bounds.left + 1,
    height: info.bounds.bottom - info.bounds.top + 1 };
  if (!Object.values(bounds).every(Number.isFinite) || bounds.left < 0 || bounds.top < 0 ||
      bounds.width <= 0 || bounds.height <= 0 || bounds.left + bounds.width > width || bounds.top + bounds.height > height) return null;
  return bounds;
}

export function plaqueArtworkGeometry(bounds, plaque, hero) {
  const targetWidth = plaque.width * .8;
  const maxHeight = Math.min(plaque.height * .32, hero.height / 1.06);
  const scale = Math.min(targetWidth / bounds.width, hero.width / 1.06 / bounds.width, maxHeight / bounds.height);
  return { scale, targetWidth, visibleWidth: bounds.width * scale, visibleHeight: bounds.height * scale,
    x: (hero.width - bounds.width * scale) / 2 - bounds.left * scale,
    y: (hero.height - bounds.height * scale) / 2 - bounds.top * scale };
}
